import { css } from "lit";
export const styles = css `
	:host {
		display: inline-block;
	}
	.w-icon {
		--_w-icon-size: var(--w-icon-size, 24px);
		height: var(--_w-icon-size);
		width: var(--_w-icon-size);
		display: flex;
	}
	.w-icon svg {
		pointer-events: none;
		height: var(--_w-icon-size);
		width: var(--_w-icon-size);
	}
	.w-icon--s {
		--w-icon-size: 16px;
	}
	.w-icon--m {
		--w-icon-size: 24px;
	}
	.w-icon--l {
		--w-icon-size: 32px;
	}
`;
//# sourceMappingURL=style.js.map